import axios from 'axios';

export const registerUser = data =>
  axios.post(`${process.env.REACT_APP_API_URL}/register`, data);

export const signInUserWithLinkedIn = () => {
  // Redirect user to LinkedIn sign in page
  window.location = `${process.env.REACT_APP_OAUTH_URL}/linkedin`;
};

export const getLinkedInUserDetails = token =>
  axios.get(`${process.env.REACT_APP_API_URL}/linkedin/result`, {
    params: {
      token,
    },
  });

export const loginUser = data =>
  axios.post(`${process.env.REACT_APP_OAUTH_URL}/token`, data);

export const loginDemoAccount = () =>
  axios.post(`${process.env.REACT_APP_OAUTH_URL}/demo`);
